import type { ReactNode } from "react";

import styles from "./home-card.module.scss";

interface HomeCardProps {
  /** Título do cartão. Omitido nos cartões do protótipo que não têm cabeçalho. */
  title?: string;
  /** Complemento à direita do título, como o total do período. */
  aside?: ReactNode;
  className?: string;
  testId: string;
  children: ReactNode;
}

/**
 * Moldura escura translúcida dos blocos da Tela Inicial, sobre a fotografia do
 * painel. Concentra fundo, borda e espaçamento em um único lugar para que cada
 * bloco cuide apenas do seu conteúdo.
 *
 * Não usa o `Card` do PrimeReact: o componente traz uma superfície clara e uma
 * sombra próprias que teriam de ser desfeitas por completo para chegar ao
 * tratamento de vidro do protótipo.
 */
export function HomeCard({ title, aside, className, testId, children }: HomeCardProps) {
  return (
    <section className={[styles.card, className].filter(Boolean).join(" ")} data-testid={testId}>
      {title || aside ? (
        <header className={styles.header}>
          {title ? <h2 className={styles.title}>{title}</h2> : null}
          {aside ? <div className={styles.aside}>{aside}</div> : null}
        </header>
      ) : null}

      {children}
    </section>
  );
}
